import { render, staticRenderFns } from "./DialogSelect.vue?vue&type=template&id=27b341fc&scoped=true&"
import script from "./DialogSelect.vue?vue&type=script&lang=js&"
export * from "./DialogSelect.vue?vue&type=script&lang=js&"
import style0 from "./DialogSelect.vue?vue&type=style&index=0&id=27b341fc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b341fc",
  null
  
)

export default component.exports